import enviro from 'enviro';
import { ENVIRO_SERVICE_NAME } from '../constants';
export const debug = () => enviro.debug(ENVIRO_SERVICE_NAME);
export const deployed = () => enviro.deployed(ENVIRO_SERVICE_NAME);
export const isLocal = () => enviro.getShort(ENVIRO_SERVICE_NAME) === 'local';